var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyWalletTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.0535 18.0666C23.4935 18.6133 23.1735 19.4 23.2535 20.24C23.3735 21.68 24.6935 22.7333 26.1335 22.7333H28.6668V24.32C28.6668 27.08 26.4135 29.3333 23.6535 29.3333H8.34683C5.58683 29.3333 3.3335 27.08 3.3335 24.32V15.3467C3.3335 12.5867 5.58683 10.3333 8.34683 10.3333H23.6535C26.4135 10.3333 28.6668 12.5867 28.6668 15.3467V17.2667H25.9735C25.2268 17.2667 24.5468 17.56 24.0535 18.0666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8002 5.26665V10.3333H8.34683C5.58683 10.3333 3.3335 12.5866 3.3335 15.3466V10.4533C3.3335 8.86667 4.30683 7.45328 5.78683 6.89328L16.3735 2.89328C18.0268 2.27994 19.8002 3.49331 19.8002 5.26665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.08 18.6266V21.3734C30.08 22.1067 29.4934 22.7066 28.7467 22.7333H26.1334C24.6934 22.7333 23.3734 21.68 23.2534 20.24C23.1734 19.4 23.4934 18.6133 24.0534 18.0666C24.5467 17.56 25.2267 17.2667 25.9734 17.2667H28.7467C29.4934 17.2933 30.08 17.8933 30.08 18.6266Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 17H9.3335C8.78683 17 8.3335 16.5467 8.3335 16C8.3335 15.4533 8.78683 15 9.3335 15H18.6668C19.2135 15 19.6668 15.4533 19.6668 16C19.6668 16.5467 19.2135 17 18.6668 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWalletTransparent);
export default __webpack_public_path__ + "static/media/empty-wallet-transparent.28249614634d95210b9625554b3460fa.svg";
export { ForwardRef as ReactComponent };